import React from 'react';

/**
 * L'affichage lorsqu'il n'y a rien à faire afficher
 * @return {JSX}
 */
function NothingToDisplay() {
  return (
    <div>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10vh'}}>
        <h1 style={{textAlign: 'center'}}>Aucun élément à afficher</h1>
      </div>
    </div>
  );
}

export default NothingToDisplay;
